// File tĩnh trong public/ (icon, ảnh nền, ảnh popup...) KHÔNG được Next gắn
// `assetPrefix` - cấu hình đó chỉ áp cho /_next/static. Viết thẳng
// src='/assets/...' thì trình duyệt tải từ chính domain của trang, tức mỗi
// icon là một request xuống pod thay vì CDN.
//
// Điều kiện và giá trị tiền tố phải khớp `assetPrefix` trong next.config.js
// và plugin postcss-asset-url.js (phần url() trong CSS).
const isProd = process.env.NEXT_PUBLIC_ENVIRONMENT !== 'dev'
const ASSET_PREFIX = isProd
  ? (process.env.NEXT_PUBLIC_CDN_WEBSITE || '').replace(/\/+$/, '')
  : ''

/**
 * Đổi đường dẫn file trong public/ thành URL qua CDN. URL tuyệt đối, đường dẫn
 * dạng `//host/...` và môi trường không cấu hình CDN được trả về nguyên vẹn.
 */
export const assetUrl = (path: string): string => {
  if (!ASSET_PREFIX || !path.startsWith('/') || path.startsWith('//')) {
    return path
  }
  return `${ASSET_PREFIX}${path}`
}
